import React from 'react';
import './InfoSection.css';
import Accordion from './Accordion';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const InfoSection = ({
  heading = 'Environmental Responsibility',
  paragraph,
  content,
  image,
  showButton = true,
  buttonText = 'IATA IEnvA certification',
  showAccordion = false,
  accordionData = []
}) => {
  const renderContent = () => {
    if (content && typeof content === 'object') {
      return documentToReactComponents(content);
    }
    return <p className="info-paragraph" style={{marginBottom:"30px"}}>{paragraph}</p>;
  };

  return (
    <div className={`info-section ${image ? 'info-section-with-image' : ''}`}>
      <div className="info-content">
        <h2 className="info-heading" style={{color:"#00238a"}}>{heading}</h2>
        <div className="info-text">
          {renderContent()}
        </div>

        {showButton && buttonText && (
          <button className="cert-button">{buttonText}</button>
        )}

        {showAccordion && accordionData.length > 0 && (
          <>
            {accordionData.map((item, index) => (
              <Accordion key={index} title={item.title}>
                {item.content}
              </Accordion>
            ))}
          </>
        )}
      </div>

      {image && (
        <div className="info-image">
          <img src={image} alt={heading} />
        </div>
      )}
    </div>
  );
};

export default InfoSection;
